import { render, staticRenderFns } from "./leagueTask.vue?vue&type=template&id=6e4520d2&scoped=true&"
import script from "./leagueTask.vue?vue&type=script&lang=js&"
export * from "./leagueTask.vue?vue&type=script&lang=js&"
import style0 from "./leagueTask.vue?vue&type=style&index=0&id=6e4520d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4520d2",
  null
  
)

export default component.exports